<script setup>
// §8.5 ClientPicker — searchable. The first half of the canonical Client →
// Bucket hierarchy. Composes LComboField so the pairing is one component
// everywhere (mobile, timesheet adjust, visit check-in, admin).
import LComboField from './ComboField.vue'

defineProps({
	clients: { type: Array, default: () => [] }, // [{ value, label, meta }]
	label: { type: String, default: 'Client' },
})
const model = defineModel({ default: null })
</script>

<template>
	<LComboField 
	v-model="model" 
	:label="label" 
	:items="clients" 
	placeholder="Select a client…"
	search-placeholder="Search clients…" />
</template>
